// A standard ref is `{ _id, name }` on the wire. Call sites that identify a
// document use `standardId`; call sites that show it use `standardName`.

export function standardId(value) {
  if (value == null || value === '') return ''
  if (typeof value === 'object') return value._id ? String(value._id) : ''
  return String(value)
}

export function standardName(value) {
  if (value && typeof value === 'object') return value.name || value.label || ''
  if (typeof value === 'string') return value
  return ''
}

// Saved nav from before standards were documents stored the name. Once the
// catalog has loaded, turn that into `{ _id, name }`. Unknown values drop out.
export function remapStoredStandard(value, standards) {
  if (!value || !standards?.length) return null
  const id = standardId(value)
  const name = typeof value === 'string' ? value : standardName(value)
  const match = standards.find((row) => {
    const sid = standardId(row.standard)
    return (id && sid === id) || row.label === name || standardName(row.standard) === name
  })
  if (!match) return null
  return { _id: standardId(match.standard), name: match.label || standardName(match.standard) }
}
